// TODO: should be marked as server-only
// import 'server-only';
import { cache as memoizedCache } from 'react';
import { Locale } from '@headless-workspace/config';
import { CatalogCategoriesRepositoryType, CommonDI } from '../../../DI';

export const getMemoCatalogCategories = memoizedCache((locale: Locale) =>
    CommonDI.get(CatalogCategoriesRepositoryType).fetchAllCategories({ locale }),
);
